<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Status </label>
          <div class="col-sm-4">
            <div>
              <el-select v-model="status" v-bind:placeholder='$t("message.PleaseSelect")'>
                <el-option v-for="item in statusSelectMap" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Centre Name </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="storeName" name="search" clearable @clear="search"></el-input>
            </div>
          </div>
        </div>
        <!-- <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Area / District </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="area" name="search" clearable @clear="search"></el-input>
            </div>
          </div>
        </div> -->
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <el-button type="primary" @click="search">{{
                $t("message.Search")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-sm-12">
                <div class="pull-right">
                  <el-button @click="gotoDetail" v-if="checkPermission('gift_store_LIST_ADD')">{{ $t("message.Add")
                  }}</el-button>
                  <!-- <el-button @click="showWarning" v-if="checkPermission('gift_store_LIST_DEL')">{{ $t("message.Delete")
                  }}</el-button> -->
                </div>
              </div>
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table :data="rows" border style="width: 100%" ref="multipleTable"
                @selection-change="handleSelectionChange" row-key="id" class="rowss">
                <el-table-column type="selection" width="55"></el-table-column>

                <el-table-column prop="storeName" label="Centre Name" width="170">
                </el-table-column>
                <el-table-column prop="tel" label="Tel">
                </el-table-column>
                <el-table-column prop="openHours" label="Opening Hours">
                </el-table-column>
                <el-table-column prop="area" label="Area / District">
                </el-table-column>
                <el-table-column prop="address" label="Address">
                </el-table-column>
                <el-table-column prop="status" label="Status">
                  <template slot-scope="scope">
                    {{ statusMap[scope.row.status] }}
                  </template>
                </el-table-column>
                <el-table-column label="Action" width="120" fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" v-if="checkPermission('gift_store_LIST_VIEW')"
                      @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
                  :total="total" style="float: right">
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import config from "../config";
import Sortable from "sortablejs";
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      total: 0,
      rows: [],
      storeName: '',
      multipleSelection: [],
      sortType: "desc",
      sortName: "title",
      area: "",
      status: ""
    };
  },
  components: {
  },
  computed: {
    statusMap() {
      return {
        0: "Disable",
        1: "Enable"
      }
    },
    statusSelectMap() {
      return [
        { value: '', label: "All" },
        { value: 0, label: "Disable" },
        { value: 1, label: "Enable" },
      ]
    }
  },
  created() {
  },
  methods: {
    async init() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.storeName = this.storeName;
      objdata.sortName = this.sortName;
      objdata.sortType = this.sortType;
      objdata.area = this.area;
      objdata.status = this.status;

      objdata.apiUrl = this.apiConfig.giftStoreList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.giftStoreList;
      this.total = data.data.result.total;
    },
    async search() {
      this.init();
    },
    async updateNewsOrder(newIndex, oldIndex) {
      var item = this.rows[oldIndex];
      this.rows.splice(oldIndex, 1);
      this.rows.splice(newIndex, 0, item);
      let sortOrder = [];
      let objdata = this.getAuthObj();
      for (let i = 0; i < this.rows.length; i++) {
        sortOrder.push({
          id: this.rows[i].id,
          displayOrder: this.rows[i].sortOrder,
        });
      }
      objdata.lstOrderDTO = sortOrder;

      objdata.apiUrl = this.apiConfig.giftStoreOrder;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.init();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/giftStoreDetail",
        query: {
          id: row.id,
        },
      });
    },
    gotoDetail() {
      this.$router.push({ path: "/main/giftStoreDetail" });
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids.join(",");

      objdata.apiUrl = this.apiConfig.giftStoreDelete;
      let data = await this.$store.dispatch("apiEventFromData", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    }
  },
  mounted() {
    this.init();
    const table = document.querySelector(".rowss .el-table__body-wrapper tbody");
    var self = this;
    Sortable.create(table, {
      onEnd({ newIndex, oldIndex }) {
        self.updateNewsOrder(newIndex, oldIndex);
      },
      filter: ".disabled",
      onMove: (event) => {
        return !event.related.classList.contains("disabled");
      },
    });
  },
};
</script>
  